// repo/primary-care-connect/frontend/src/pages/Portal/CommunityNavigator/CaseDetail/intakeOptions.ts

import type { SelectOption } from "./types";

export const yesNoNotSureOptions: SelectOption[] = [
  { value: "", label: "Not answered" },
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
  { value: "notSure", label: "Not sure" },
];

export const yesNoPreferNotOptions: SelectOption[] = [
  { value: "", label: "Not answered" },
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
  { value: "preferNotToSay", label: "Prefer not to say" },
];

export const requestForOptions: SelectOption[] = [
  { value: "", label: "Not selected" },
  { value: "Self", label: "Myself" },
  { value: "Child", label: "My child" },
  { value: "SpousePartner", label: "Spouse / partner" },
  { value: "Parent", label: "Parent" },
  { value: "OtherFamilyMember", label: "Other family member" },
];

export const familyDoctorSituationOptions: SelectOption[] = [
  { value: "", label: "Not selected" },
  {
    value: "DoctorMoved",
    label: "My family doctor moved to another community.",
  },
  {
    value: "PatientMoved",
    label:
      "I moved to another community and no longer have access to my previous family doctor.",
  },
  {
    value: "DoctorUnavailableRetiredIllnessDeath",
    label:
      "My family doctor is no longer available due to retirement, illness, or death.",
  },
  {
    value: "DoctorUnavailablePracticeChange",
    label:
      "My family doctor is no longer available due to a change in their practice.",
  },
  {
    value: "NeverHadFamilyDoctor",
    label: "I have not previously had or felt the need for a family doctor.",
  },
  {
    value: "DoctorEndedRelationship",
    label: "My family doctor ended the doctor-patient relationship.",
  },
  {
    value: "WantsToSwitch",
    label:
      "I currently have a family doctor but want to switch for my own reasons.",
  },
  {
    value: "OtherNonMedical",
    label: "Other non-medical reason.",
  },
];

export const multipleBirthOptions: SelectOption[] = [
  { value: "", label: "Not answered" },
  { value: "no", label: "No" },
  { value: "twins", label: "Twins" },
  { value: "tripletsOrMore", label: "Triplets or more" },
  { value: "notSure", label: "Not sure" },
];

export const priorityOverrideOptions: SelectOption[] = [
  { value: "", label: "Use system-calculated priority" },
  { value: "Routine", label: "Routine" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Urgent", label: "Urgent navigator attention" },
];

export const priorityOverrideReasonOptions: SelectOption[] = [
  { value: "", label: "Select reason" },
  { value: "NavigatorJudgment", label: "Navigator judgment after conversation" },
  {
    value: "SafetyConcern",
    label: "Safety concern / urgent follow-up concern",
  },
  {
    value: "CommunicationBarrier",
    label: "Patient unreachable / communication barrier",
  },
  { value: "OhtDirectedPriority", label: "OHT-directed priority" },
  { value: "Other", label: "Other - note required" },
];